if (!customElements.get('sigsag-members')) {
  customElements.define('sigsag-members', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.teaser = this.querySelector('[data-members-open]');
      this.form = this.querySelector('form');
      this.storeKey = 'sigsag-members-v1';
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.teaser.addEventListener('click', () => this.open(), options);
      this.querySelectorAll('[data-members-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', event => {if(event.target === this.dialog) {const rect = this.dialog.getBoundingClientRect(); if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();}}, options);
      this.dialog.addEventListener('close', () => {this.save({dismissed:Date.now()}); if(this.oldOverflow !== undefined) document.documentElement.style.overflow = this.oldOverflow;}, options);
      this.form.addEventListener('submit', event => this.submit(event), options);
      if(this.querySelector('[data-members-form-state]').dataset.membersFormState === 'success') {this.success(); this.open(); return;}
      if(this.querySelector('[data-members-form-state]').dataset.membersFormState === 'error') {this.open(); return;}
      const state = this.read();
      if(this.dataset.knownSubscriber === 'true' || state.joined) {this.teaser.hidden = true; return;}
      if(this.dataset.designMode === 'true' || (state.dismissed && Date.now() - state.dismissed < 14*86400000)) return;
      this.timer = setTimeout(() => this.maybeOpen(), Math.max(5,Number(this.dataset.delay)||12)*1000);
    }
    disconnectedCallback() {clearTimeout(this.timer); this.abort?.abort(); if(this.dialog?.open && this.oldOverflow !== undefined) document.documentElement.style.overflow=this.oldOverflow;}
    read() {try{return JSON.parse(localStorage.getItem(this.storeKey)||'{}')||{};}catch{return {};}}
    save(values) {try{localStorage.setItem(this.storeKey,JSON.stringify({...this.read(),...values}));}catch{}}
    maybeOpen(attempt = 0) {
      if(this.read().joined) return;
      const busy = document.hidden || document.querySelector('dialog[open], .mfp-ready, .t4s-drawer[aria-hidden="false"], .t4s-drawer.t4s-active, [data-sigsag-cart-drawer][open]') || document.activeElement?.matches('input,textarea,select');
      if(busy) {if(attempt < 8) this.timer=setTimeout(()=>this.maybeOpen(attempt+1),5000); return;}
      this.open();
    }
    open() {
      if(this.dialog.open) return;
      this.oldOverflow=document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow='hidden';
      this.querySelector('[data-members-close]').focus({preventScroll:true});
      this.dispatchEvent(new CustomEvent('sigsag:signup-view',{bubbles:true}));
    }
    success() {
      this.querySelector('[data-members-signup]').hidden=true;
      this.querySelector('[data-members-success]').hidden=false;
      this.dialog.setAttribute('aria-labelledby','SigsagMembersSuccess');
      this.dialog.removeAttribute('aria-describedby');
      const title=this.querySelector('[data-members-success-title]');title.id='SigsagMembersSuccess';
      this.teaser.hidden=true;
      this.save({joined:true});
      title.focus({preventScroll:true});
      this.dispatchEvent(new CustomEvent('sigsag:email-signup',{bubbles:true}));
    }
    submit(event) {
      if(!this.form.checkValidity()) return;
      this.querySelector('[data-members-error]').hidden=true;
      this.dialog.close();
    }
  });
}
